import { Carousel, Container, Row, Col } from "react-bootstrap";
import sh1 from "Media/san1.jpg";
import sh2 from "Media/san2.jpg";
import sh3 from "Media/san3.jpg";

import { useTranslation } from "react-i18next";
import YouTube from "react-youtube";
function Santehnika() {
  const { t } = useTranslation();

  return (
    <>
      <Container>
        <Row>
          <Col>
            <h4 style={{ textAlign: "center" }}>{t("Santehnika")}</h4>
          </Col>
        </Row>
        <Row>
          <Col lg={6}>
            <p style={{ textAlign: "center" }}> <strong> {t("Santehnika_text1")} </strong> </p>
            <ul>
              <li>{t("Santehnika_li1")}</li>
              <li>{t("Santehnika_li2")}</li>
              <li>{t("Santehnika_li3")}</li>
              <li>{t("Santehnika_li4")}</li>
              <li>{t("Santehnika_li5")}</li>
            </ul>
            <p style={{ textAlign: "center" }}> <strong> {t("Santehnika_text2")} </strong> </p>
            <ul>
              <li>{t("Santehnika_li6")}</li>
              <li>{t("Santehnika_li7")}</li>
              <li>{t("Santehnika_li8")}</li>
              <li>{t("Santehnika_li9")}</li>
            </ul>
          </Col>
          <Col lg={6} className="my-3">
            <YouTube
              videoId="y2_fhm0B8_o"
              containerStyle={{ minHeight: "300px" }}
              className="w-100 h-100"
              containerClassName="w-100 h-100"
            />
          </Col>
        </Row>
        <Row className="pb-5 px-3 justify-content-center">
          <Col lg={8} className="my-3">
            <Carousel style={{ maxHeight: "90vh", objectFit: "cover" }}>
              <Carousel.Item style={{ maxHeight: "90vh", objectFit: "cover" }}>
                <img className="d-block w-100" style={{ maxHeight: "90vh", objectFit: "cover" }} src={sh1} alt="First slide" />
                <Carousel.Caption>
                  <h3>{t("Santehnika_slide1")}</h3>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item style={{ maxHeight: "90vh", objectFit: "cover" }}>
                <img className="d-block w-100" style={{ maxHeight: "90vh", objectFit: "cover" }} src={sh2} alt="Second slide" />

                <Carousel.Caption>
                  <h3>{t("Santehnika_slide2")}</h3>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item style={{ maxHeight: "90vh", objectFit: "cover" }}>
                <img className="d-block w-100" style={{ maxHeight: "90vh", objectFit: "cover" }} src={sh3} alt="Third slide" />

                <Carousel.Caption>
                  <h3>{t("Santehnika_slide3")}</h3>
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </Col>
        </Row>
      </Container >
    </>
  );
}

export { Santehnika };
